import axios from 'axios'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || window.location.origin,
  timeout: 15000
})

request.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

request.interceptors.response.use(
  response => {
    const data = response.data
	console.log(123);
    if (data && data.code !== undefined && data.code !== 200) {
      return Promise.reject(new Error(data.message || 'Request failed'))
    }
    return data
  },
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      if (location.pathname !== '/login') {
        location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default request
